import { Modal, Box, Typography, TextField, Button, Stack } from "@mui/material";
import { useState } from "react";
import { useAuth } from "src/hooks/useAuth";

const ChangePasswordModal = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
    const auth = useAuth()
    const [form, setForm] = useState({
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
    })

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState({
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
    });

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        const updatedForm = {
            ...form,
            [name]: value
        };

        if (name === 'newPassword' || name === 'confirmPassword') {
            if (updatedForm.newPassword && updatedForm.confirmPassword &&
                updatedForm.newPassword !== updatedForm.confirmPassword) {
                setError({
                    ...error,
                    confirmPassword: 'New passwords do not match.'
                });
            } else {
                setError(prev => ({
                    ...prev,
                    confirmPassword: ''
                }));
            }
        }

        setForm(updatedForm);
    };

    const handleSubmit = () => {
        setLoading(true);
        const token = auth.user?.token || ''
        auth.currentUserChangePassword({ oldPassword: form.oldPassword, newPassword: form.newPassword, token }, () => {
            setLoading(false);
            handleClose();
        }, (err) => {
            setLoading(false);
            setError({
                oldPassword: err.toString(),
                newPassword: '',
                confirmPassword: ''
            })
        })
    };

    const handleClose = () => {
        onClose();
        setForm({ oldPassword: '', newPassword: '', confirmPassword: '' });
        setError({
            oldPassword: '',
            newPassword: '',
            confirmPassword: ''
        });
    }

    return (
        <Modal open={open} onClose={handleClose}>
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: { xs: '90%', sm: '80%', md: '400px' },
                    maxWidth: '100%',
                    maxHeight: '90vh',
                    overflowY: 'auto',
                    bgcolor: 'background.paper',
                    borderRadius: 2,
                    boxShadow: 24,
                    p: { xs: 2, sm: 3, md: 4 },
                    '&:focus-visible': {
                        outline: 'none'
                    }
                }}
            >
                <Typography variant="h6" mb={3} textAlign="center">
                    Change Password
                </Typography>
                <Stack spacing={2}>
                    <TextField
                        fullWidth
                        label="Old Password"
                        name="oldPassword"
                        type="password"
                        value={form.oldPassword}
                        onChange={handleInputChange}
                        error={!!error.oldPassword}
                        helperText={error.oldPassword}
                        size="small"
                    />
                    <TextField
                        fullWidth
                        label="New Password"
                        name="newPassword"
                        type="password"
                        value={form.newPassword}
                        onChange={handleInputChange}
                        error={!!error.newPassword}
                        helperText={error.newPassword}
                        size="small"
                    />
                    <TextField
                        fullWidth
                        label="Confirm Password"
                        name="confirmPassword"
                        type="password"
                        value={form.confirmPassword}
                        onChange={handleInputChange}
                        error={!!error.confirmPassword}
                        helperText={error.confirmPassword}
                        size="small"
                    />
                    <Stack direction="row" spacing={2} justifyContent="flex-end" mt={2}>
                        <Button variant="outlined" onClick={handleClose} fullWidth>
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            onClick={handleSubmit}
                            disabled={loading || !form.oldPassword || !form.newPassword || !form.confirmPassword || form.newPassword !== form.confirmPassword}
                            fullWidth
                        >
                            {loading ? 'Changing...' : 'Confirm'}
                        </Button>
                    </Stack>
                </Stack>
            </Box>
        </Modal>
    );
};

export default ChangePasswordModal;
